import { mapState } from 'vuex';
import router from '../router';
import { routerCheckInitialStepComplete } from '../utils';

export default {
    name: 'ActivityForm',
    template: '#activity-form-template',
    beforeRouteEnter: routerCheckInitialStepComplete,
    data() {
        return {
            submissionError: null
        }
    },
    computed: {
        ...mapState([
            'permitNumber',
            'permitYear',
            'permitValidated',
            'facilityUsages',
            'businessName',
            'contactPerson',
            'pendingAsyncRequest',
            'clientDaysHelpText'
        ]),
        email: {
            get() {
                return this.$store.state.email;
            },
            set(value) {
                this.$store.dispatch('setEmail', value);
            }
        },
        zeroFacilityUsagesReport: {
            get() {
                return this.$store.state.zeroFacilityUsagesReport;
            },
            set(value) {
                this.$store.dispatch('setZeroFacilityUsagesReport', value);
            }
        },
        totalCost() {
            return this.$store.state.facilityUsages ? this.$store.state.facilityUsages.reduce((accumulator, currentValue) => {
                return accumulator + currentValue.clientDays * currentValue.fee;
            }, 0) : 0;
        },
        showCheckoutButton() {
            return this.$store.state.facilityUsages && this.$store.state.facilityUsages.length;
        },
        reportIsAllZeroUsage() {
            return this.totalCost === 0;
        }
    },
    methods: {
        submitFormHandler() {
            if ($('#customer-information-form').valid()) {
                return this.$store.dispatch('submitUsageReport')
                    .then(r => {
                        if (!r.result) {
                            this.submissionError = r.message;
                            return r;
                        }

                        this.submissionError = null;

                        if (this.$store.state.isZeroFacilityUsagesReportSubmission || r.zeroFacilityUsagesReport) {
                            router.push(`/${this.permitNumber}/${this.permitYear}/no-usage-confirmation`);
                        }

                        return r;
                    });
            }
            else {
                $('#customer-information-form #customer-email').focus();
            }
        }
    }
};